<template>
    <div class="layout-b">
        
        <!-- aside -->
        <div class="aside-scrollbar">
            <Aside></Aside>
        </div>

        <!-- main -->
        <div class="main-b">

            <Notification></Notification>

            <div style="height: 50px; border-bottom: 1px solid #ebeef5; box-sizing: border-box;">
                <Header :hide="hide"></Header>
            </div>
            
            <div style="height: calc(100vh - 50px); padding: 20px; box-sizing: border-box;">

                <!-- <transition  mode="out-in"> -->
                    <router-view/>
                <!-- </transition> -->
            </div>
            
        </div>
        
    </div>
</template>

<script>
    import Aside from '@/components/aside'
    import Header from '@/components/header'
    import Notification from '@/components/notification/index.vue'

    export default {
        name: '',
        
        components: {
            Aside,
            Header,
            Notification,
        },

        data() {
            return {
                hide: true,
            }
        },

        mounted() {
        
            //初始化音频
            this.audio = new Audio('/audio/remind.mp3');

            this.clickAudio();
        },

        methods: {

            //解锁音频(首次),激活音频
            unlockAudio() {

                if( !this.audio ) return;

                //this.audio.muted = true; //开启静音
                //this.audio.muted = false; //解除静音

                this.audio.play(); //播放

                this.audio.pause(); //暂停正在播放的音频

                this.audio.currentTime = 0; //重置音频播放进度,为0起始位

                document.removeEventListener('click', this.unlockAudio); //移除事件监听
                
                this.hide = false;

                //没有声音解决?
                //1.刷新页面,点击页面任意元素, 激活音频, 听到提示音。
                //2.在首次登录网站后, 需要点击一次页面任意元素, 激活音频, 听到一块滴
                //3.页面刷新后, 需要再次点击页面任意元素激活
                
            },

            //点击任意页面位置激活音频
            clickAudio() {
                //监听整个页面的点击事件
                document.addEventListener('click', this.unlockAudio);
            }

        }
    }      
</script>

<style scoped>
    .layout-b {
        height: 100vh;
        display: flex;
    }

    .aside-scrollbar {
        overflow-y: auto;
        border-right: 1px solid #ebeef5;
    }

    .aside-scrollbar::-webkit-scrollbar {
        display: none;
    }

    .main-b {
        flex: 1;
        min-width: 0;
        background-color: #fff;
    }

    /* vue过渡效果 */
    /* #region */
    /* 进入的起点 */
    .v-enter {
        transform: translateX(-20px);
        opacity: 0;
    }

    /* 进入的终点 */
    .v-enter-to {
        transform: translateX(0);
    }

    /* 过渡-进入 */
    .v-enter-active {
        transition: all 0.4s;
    }

    /* 离开的起点 */
    .v-leave {
        transform: translateX(0);
    }

    /* 离开的终点 */
    .v-leave-to {
        transform: translateX(20px);
        opacity: 0;
    }

    /* 过渡-离开 */
    .v-leave-active {
        transition: all 0.4s;
    }
    /* #endregion */

</style>